var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.root,attrs:{"id":_vm.id,"tabIndex":"-1"}},[_c('div',{ref:"body",class:_vm.$style.body},[_c('span',{ref:"top",class:_vm.$style.intersectTop,attrs:{"data-pos":"top"}}),_vm._t("default"),_c('span',{ref:"bottom",class:_vm.$style.intersectBottom,attrs:{"data-pos":"bottom"}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031c93cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/assets/js/components/Page/index.vue
// module id = 0zuE
// module chunks = 2